export const PATIENT_URL = 'https://melmo-app.com/';
export const PATIENT_TERM_URL = 'https://melmo-app.com/terms';
export const PATIENT_PRIVACY_POLICY_URL = 'https://www.medley.jp/medical-platform/privacy.html';

export const DOMAIN_NAME = 'kakaritsuke.medixs.jp';

export const MEDICAL_INFORMATION_NET_URL =
  'https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/kenkou_iryou/iryou/newpage_43373.html';
